<template>
  <div id="add">
    <div class="box">
      <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> StandBy Lessons</div>
    </div>
    <hr>
    <form class="box">
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="field">
            <multiselect v-model="school" :disabled="disableSchool" label="name" name="schools" track-by="id" :options="schools" placeholder="Choose school"></multiselect>
          </div>
        </div>
      </div>
      <div v-if="school.name === MAGIC_EARS.name">
        <m-e-lesson :lessonForUpdate="lesson" :update="update" :loading="loading" @save="save"></m-e-lesson>
      </div>
      <div v-else-if="school.name === VIPKID.name">
        <v-k-lesson :lessonForUpdate="lesson" :update="update" :loading="loading" @save="save"></v-k-lesson>
      </div>
      <div v-else>
        <rest-lesson :lessonForUpdate="lesson" :update="update" :loading="loading" @save="save"></rest-lesson>
      </div>
    </form>
  </div>
</template>

<script>

  import MELesson from './MELesson';
  import VKLesson from './VKLesson';
  import RestLesson from './RestLesson';

  export default {
    name: 'sb-lessons-add',
    props:{
      lesson: { required: true },
      update: { required: false, default: false },
      disableSchool: { required: false, default: false },
    },
    components: {MELesson, VKLesson, RestLesson},
    data() {
      return {
        loading: false,
        school: {},
      }
    },
    created(){
      if(this.schools.length == 0){
        this.loadSchools();
      }
    },
    methods: {
      save (lesson) {
        let self = this;
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.loading = true
            if (this.update) {
              self.stbyLessonRepo.update(lesson.id, lesson).then(function (response) {
                self.loading = false
                self.$toast.success(response.data.message)
                self.$router.push('/dashboard/sb-lessons')
              }).catch(function (response) {
                self.loading = false
              })
            } else {
              self.stbyLessonRepo.store(lesson).then(function (response) {
                self.loading = false
                self.$toast.success(response.data.message)
                self.$router.push('/dashboard/sb-lessons')
              }).catch(function (response) {
                self.loading = false
              })
            }
          }
        })
      },

    },
    watch: {

      'schools':function (schools) {
        if(schools.length > 0){
          let school = this.lesson.school ? this.lesson.school : schools[0];
          this.school = school;
        }
        //this.stbySchools(this.schools);
      },
      'school':function (school) {
        this.lesson.school_id = school.id;
      },
      'lesson':function(lesson) {

        if(this.lesson.additionalInfo.name === ''){
          this.lesson.additionalInfo.name = lesson.name;
        }
        if(this.lesson.additionalInfo.provider_full_id === ''){
          this.lesson.additionalInfo.provider_full_id = lesson.provider_id;
        }
        if(this.lesson.additionalInfo.words === ''){
          this.lesson.additionalInfo.words = lesson.words;
        }
        console.log(lesson);
      },
    },

  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/components/STBYLesson.vue